import React from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components";
import NavbarView from "../views/NavbarView";
import FooterView from "../views/FooterView";
import { useMediaQuery } from "@mui/material";
import theme from "../../theme";

interface Props {}

const Root = styled.div`
  width: 100%;
`;

const Wrapper = styled.div`
  // flex: 1 1 auto;
  // height: 100%;
  overflow: auto;
  // position: relative;
  padding-top: 70px;
`;

const DefaultLayout: React.FC<Props> = (props) => {
  const md = useMediaQuery(theme.breakpoints.up("md"));
  return (
    <Root>
      <NavbarView />
      <Wrapper>
        <Outlet />
      </Wrapper>
      {md && <FooterView />}
    </Root>
  );
};

export default DefaultLayout;
